export enum enumBondRequestState {
  CREATED,
  SENT,
  COMPLETED,
  CUSTOM,
}
